import { SET_CAMPUS } from "../actions/seminarActions";

interface SeminarReducerState {
    campus: any
}

const initialState: SeminarReducerState = {
    campus : undefined 
 }

const seminarReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_CAMPUS:
            return {
                ...state,
                campus: action.value
            }
        default:
            return state;
    }
}



export default seminarReducer;